import PropTypes from 'prop-types';
import mark from '../../../assets/images/tick.svg';
import { Button, ModalComponent } from '../../../common/components';
import { ACTION_NEW } from '../../../constants/gl-configuration';

const CreatedSuccessModal = ({ isOpen, toggle, action, selectedValue }) => {
  const NewCreatedSuccessModal = () => {
    return (
      <div className="acconut-number-modal">
        <div className="acc-close" onClick={toggle}>
          <i className="fas fa-times" />
        </div>
        <div className="acconut-number-modal-div">
          <div className="acc-img">
            <img src={mark} alt="icon" />
          </div>
          <div className="acc-number-created">
            <p>{action === ACTION_NEW ? action : null} Account Number</p>
            <p className="acc-number">{selectedValue?.accountNumber}</p>
            <p className="acc-number">{selectedValue?.description}</p>
            <p>successfully {action === ACTION_NEW ? 'created' : 'updated'}.</p>
          </div>
          <hr />
          <Button color="primary" className="atd-btn acc-btn" onClick={toggle}>
            Close
          </Button>
        </div>
      </div>
    );
  };

  return (
    <ModalComponent isOpen={isOpen} toggle={toggle} className="EmailModalWrapper acc-success-modal">
      {NewCreatedSuccessModal()}
    </ModalComponent>
  );
};

CreatedSuccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  action: PropTypes.string,
  selectedValue: PropTypes.shape({
    accountNumber: PropTypes.string,
    description: PropTypes.string,
  }),
};

CreatedSuccessModal.defaultProps = {
  action: ACTION_NEW,
  selectedValue: { accountNumber: '', description: '' },
};
export default CreatedSuccessModal;
